import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { EventsService } from 'src/app/services/event/event.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';

@Component({
    selector: 'app-signup-result',
    templateUrl: './signup-result.component.html',
    styleUrls: ['./signup-result.component.scss'],
})
export class SignupResultComponent implements OnInit {


    public wasSuccessful: boolean = true;
    public responsibleGamingNumber: string;
    public startupBoydRewardEnrollPopupEnabled: number;

    constructor(
        protected config: ConfigService,
        protected userSessionService: UserSessionService,
        protected utils: UtilsService,
        private eventsService: EventsService,
        private lobbyService: LobbyService,
        private navigator: Navigator,
        public authenticationService: AuthenticationService,
    ) { }

    ngOnInit(): void {
        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER ?? '1-800-522-4700';
        this.startupBoydRewardEnrollPopupEnabled = parseInt(this.config.getConfig().BOYD_REWARDS_ENROLL_START) ?? 0;
    }

    ionViewCanLeave() {
        localStorage.setItem('MFA.signup', 'false');
    }

    closeSuccessModal = () => {
        setTimeout(() => {
            this.activateCustomer();
        }, 500);
    }

    protected openPage(page) {
        return this.navigator.navigateTo(page, { multipleModals: true }, { previousPage: "SignupResult" });
    }

    protected redirectUserToLobby(): void {
        //this.appActions.redirectAfterSuccessfulRegistration();
        this.eventsService.publish("event:login", {
            customer_id: this.userSessionService.getCustomerId(),
          });
        this.eventsService.publish('action:changeTab', 'casino');
    }

    private activateCustomer = () => {
        localStorage.setItem('MFA.signup', 'false');
        this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
            this.lobbyService.setCurrentLoginTime(customer.currentLoginTime);
            /*setTimeout(()=> {
                this.bannerProvider.fetchAllBanners();
            }, 2000);*/


            this.userSessionService.setUserStatus({
                customerId: this.userSessionService.getCustomerId(),
                sessionToken: this.userSessionService.getSessionToken()
            })
        });

        this.redirectUserToLobby();
        this.eventsService.publish("event:notifications:start");
    }

}
